export default "__VITE_ASSET__BXlq7YCa__"